import nBossConnection from 'service/nBossConnection';
import AccessConfigDto from 'dto/user/AccessConfigDto';

class AccessManagementService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'accessManagement';
	}

	/**
	 * @param {string} email
	 * @param {string} password
	 * @return {Promise<boolean>}
	 */
	login(email, password) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/login`, {
					email,
					password
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @return {Promise<AccessConfigDto>}
	 */
	getAccessConfig() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getAccessConfig`)
				.then(response => resolve(new AccessConfigDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @return {Promise<Object>}
	 */
	getServiceRolesMap() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getServiceRolesMap`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @return {Promise<Object>}
	 */
	isLoggedInAnyone() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/isLoggedInAnyone`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new AccessManagementService();
